<template>
  <el-drawer :visible.sync="visible" :with-header="false" size="800px" :before-close="closeDialog">
    <div class="flex-column height-100">
      <div class="flex-row-center-v padding border-b">
        <span class="flex-1 text-lg">列表定制</span>
        <el-button size="small" type="primary" plain icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
        <el-button size="small" plain icon="el-icon-close" @click="closeDialog">关闭</el-button>
      </div>
      <el-table ref="TableRef" class="table-flex margin-t table-sortable" :data="list" border height="100%">
        <el-table-column type="index" width="60" align="center" label="序号" />
        <el-table-column label="排序" width="50" align="center">
          <template>
            <div class="flex-row-center table-drop-item cursor-move">
              <img style="width: 16px; height: 16px;" src="@/assets/image/icon-drop.png" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="100" align="center" />
        <el-table-column label="列宽(PX)" width="120" align="center">
          <template #default="scope">
            <el-input-number
              class="width-100"
              v-model="scope.row.width"
              :min="60"
              :max="500"
              controls-position="right"
              size="mini"
            />
          </template>
        </el-table-column>
        <el-table-column label="对齐方式" width="120" align="center">
          <template #default="scope">
            <el-select class="width-100" v-model="scope.row.align" size="mini" placeholder="请选择">
              <el-option label="居左" value="left" />
              <el-option label="居中" value="center" />
              <el-option label="居右" value="right" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="文字颜色" width="120" align="center">
          <template #default="scope">
            <div class="flex-row-center">
              <el-color-picker v-model="scope.row.color" size="mini" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否隐藏" width="100" align="center">
          <template #default="scope">
            <el-switch v-model="scope.row.hide" :active-value="1" :inactive-value="0" />
          </template>
        </el-table-column>
        <el-table-column label="是否固定" width="100" align="center">
          <template #default="scope">
            <el-select class="width-100" v-model="scope.row.fixed" size="mini" placeholder="请选择">
              <el-option label="不固定" value="" />
              <el-option label="列首" value="left" />
              <el-option label="列尾" value="right" />
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
import { useSortUtil } from '@/utils/sort'
import { cloneDeep } from 'lodash'
import { useTableUtil } from '@/utils/table'

export default {
  name: 'KqTableConfig',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    configParams: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sortable: null,
      list: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.list = cloneDeep(this.configParams)
        this.$nextTick(() => {
          this.sortable = useSortUtil.initTableSort({ callback: this.handleSortChange })
        })
      }
    }
  },
  methods: {
    /**
     * 排序
     */
    handleSortChange(e) {
      const list = useSortUtil.sort(this.list, e)
      this.list = []
      this.$nextTick(() => {
        this.list = list
      })
    },

    /**
     * 重置
     */
    handleReset() {
      this.list = []
      this.$nextTick(() => {
        this.list = useTableUtil.getTableConfig(this.type)
      })
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      useTableUtil.saveTableConfig(this.type, this.list)
      useSortUtil.destroy(this.sortable)
      this.sortable = null
      this.$emit('update:visible', false)
      this.$emit('callback', this.type, this.list)
    }
  }
}
</script>
